import DPO from 'dpo8core';
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { setScaleParams } from '@app/actions/customizeActions';
import LocalizedText from '@LocalizedText';
import { connect } from 'react-redux';
import { inject } from '@app/providers/QAU.ContextProvider';

import './LockArtworkRatio.scss';

const LockArtworkRatio = ({
  aspectRatioLocked,
  setScaleParams,
  flow,
}) => {
  const aspectRatioRef = useRef();

  const setAspectRatio = useCallback(
    ({ target: { checked } }) => {
      const {
        editor: { transformTool },
      } = flow;

      const trackingControls = transformTool.settings.trackingControls;
      const keepAspectRatio = checked ? [DPO.model.Barcode, DPO.model.Image, DPO.model.Drawing] : [];

      for (let i = 1; i < trackingControls.length; i += 2) {
        trackingControls[i].params.keepAspectRatio = keepAspectRatio;
      }

      setScaleParams({ aspectRatioLocked: !!checked });
    },
    [flow, setScaleParams],
  );

  return (
    <div id="lock-artwork-ratio-tool">
        <label htmlFor="lock-artwork-ratio-checkbox">
          <input
            type="checkbox"
            ref={aspectRatioRef}
            id="lock-artwork-ratio-checkbox"
            onChange={setAspectRatio}
            defaultChecked={aspectRatioLocked}
          />
          <LocalizedText id="qau-lock-artwork-ratio-tool-text" tagName="span" />
        </label>
    </div>
  );
};

const mapStateToProps = ({
  customize: {
    customizeData: {
      scaleParams: { aspectRatioLocked },
    },
  },
}) => ({ aspectRatioLocked });

const mapDispatchToProps = { setScaleParams };

LockArtworkRatio.propTypes = {
  flow: PropTypes.object.isRequired,
  setScaleParams: PropTypes.func.isRequired,
  aspectRatioLocked: PropTypes.bool.isRequired,
};

export default inject('flow')(connect(mapStateToProps, mapDispatchToProps)(LockArtworkRatio));
